import { ChangeDetectionStrategy, Component, ElementRef } from "@angular/core";
import _ from "lodash";
import { SmFormService } from "../sm-form-service";
import { SmFormFieldBase } from "./sm-form-field-base.component";

@Component({
    standalone: false,
    selector: 'sm-form-field-integer',
    templateUrl: './sm-form-field-integer.component.html',
    outputs: ['onValueChanged', 'onFocusChanged'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmFormFieldIntegerComponent extends SmFormFieldBase {

    constructor(protected service: SmFormService, protected element: ElementRef) {
        super(service, element);
    }

    public valueChange(e: any) {
        this.model.Value =  e;
        super.valueChange(e, 'input');
    }
}